(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      Array.prototype.slice.call(root.querySelectorAll('details')).forEach(function (d) {
        var body = d.querySelector('.ocea-faq__a'); var q = d.querySelector('summary');
        q.addEventListener('click', function (e) {
          e.preventDefault();
          if (d.open && !d.classList.contains('is-closing')) {
            if (REDUCED.matches) { d.open = false; return; }
            d.classList.add('is-closing');
            var done = function () { d.open = false; d.classList.remove('is-closing'); body.removeEventListener('transitionend', done); };
            body.addEventListener('transitionend', done); setTimeout(done, 340);
          } else { d.classList.remove('is-closing'); d.open = true; }
        });
      });
    }
    document.querySelectorAll('.ocea-faq').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-faq'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-how-to-take"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* свайп-лента на 768/402: фото за краем экрана грузим заранее; высота полного описания → --full (для плавного раскрытия по наведению) */
    function measure(root) {
      root.querySelectorAll('.ocea-how__card-body').forEach(function (b) {
        var full = b.querySelector('.ocea-how__card-full'); if (full) b.style.setProperty('--full', full.offsetHeight + 'px');
      });
    }
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var lane = root.querySelector('.ocea-how__steps'); if (lane && window.Ocea) Ocea.eagerNear(lane);
      measure(root);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(root); });
      var t = null; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { measure(root); }, 150); });
    }
    document.querySelectorAll('.ocea-how').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-how'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TOUCH = window.matchMedia('(max-width: 1023px)');
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var grid = root.querySelector('[data-ocea-ingredients]'); if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ocea-ing]'));

      /* 1920/1280: подсказка по наведению мыши и по фокусу с клавиатуры; тап на десктопной ширине — переключает */
      function activate(card) {
        cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
        grid.classList.toggle('is-hovering', !!card);
      }
      cards.forEach(function (card) {
        var btn = card.querySelector('[data-ocea-ing-toggle]'), lastType = 'mouse';
        card.addEventListener('pointerdown', function (e) { lastType = e.pointerType; });
        card.addEventListener('pointerenter', function (e) { if (!TOUCH.matches && e.pointerType === 'mouse') activate(card); });
        btn.addEventListener('focus', function () { if (!TOUCH.matches && btn.matches(':focus-visible')) activate(card); });
        btn.addEventListener('blur', function () { if (!TOUCH.matches && !grid.matches(':hover')) activate(null); });
        btn.addEventListener('click', function (e) {
          if (!TOUCH.matches) {
            if (e.detail === 0 || lastType === 'mouse') return;
            activate(card.classList.contains('is-active') ? null : card); return;
          }
          /* 768/402: открыта не больше одной строки, повторный тап сворачивает */
          var open = !card.classList.contains('is-open');
          cards.forEach(function (c) {
            var on = c === card && open;
            c.classList.toggle('is-open', on);
            c.querySelector('[data-ocea-ing-toggle]').setAttribute('aria-expanded', on ? 'true' : 'false');
          });
        });
      });
      grid.addEventListener('pointerleave', function (e) { if (!TOUCH.matches && e.pointerType === 'mouse') activate(null); });
      /* aria: на тач-ширинах — аккордеон (aria-expanded), на десктопе — подсказка (aria-describedby) */
      function sync() {
        cards.forEach(function (c) {
          var btn = c.querySelector('[data-ocea-ing-toggle]'), id = btn.getAttribute('aria-controls');
          if (TOUCH.matches) { btn.setAttribute('aria-expanded', c.classList.contains('is-open') ? 'true' : 'false'); btn.removeAttribute('aria-describedby'); }
          else { btn.removeAttribute('aria-expanded'); if (id) btn.setAttribute('aria-describedby', id); }
        });
      }
      if (TOUCH.addEventListener) TOUCH.addEventListener('change', function () { activate(null); sync(); });
      sync();

      /* «Show all 11 ingredients»: раскрытие 0.35s, обратно не сворачивается */
      var more = grid.querySelector('[data-ocea-ingredients-more]');
      if (more) more.addEventListener('click', function () {
        var h0 = grid.offsetHeight;
        root.classList.add('is-expanded'); more.setAttribute('aria-expanded', 'true');
        if (window.Ocea && Ocea.reduced && Ocea.reduced.matches) return;
        var h1 = grid.offsetHeight;
        grid.style.height = h0 + 'px'; grid.offsetHeight; grid.classList.add('is-animating'); grid.style.height = h1 + 'px';
        var done = function () { grid.classList.remove('is-animating'); grid.style.height = ''; grid.removeEventListener('transitionend', done); };
        grid.addEventListener('transitionend', done); setTimeout(done, 450);
        var first = grid.querySelector('.is-extra [data-ocea-ing-toggle]'); if (first) first.focus({ preventScroll: true });
      });
    }
    document.querySelectorAll('.ocea-ingredients').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-ingredients'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var burger = root.querySelector('[data-ocea-burger]'); var menu = root.querySelector('[data-ocea-menu]');
      if (!burger || !menu) return;
      var page = root.closest('.ocea-page') || document.body;
      function set(open) {
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.hidden = !open; root.classList.toggle('is-open', open); page.classList.toggle('is-menu-open', open);
      }
      burger.addEventListener('click', function () { set(menu.hidden); });
      menu.addEventListener('click', function (e) { if (e.target.closest('a') || e.target.closest('[data-ocea-menu-dim]')) set(false); });
      window.addEventListener('resize', function () { if (window.innerWidth > 1179 && !menu.hidden) set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
    }
    document.querySelectorAll('.ocea-navbar').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-navbar'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* --- тарифы: радио → классы, цены, подарки, Ocea.setPlan --- */
    function initPlans(root, form) {
      var inputs = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
      if (!inputs.length) return;
      var price = root.querySelector('[data-ocea-price]'), save = root.querySelector('[data-ocea-save]');
      var ctaWas = root.querySelector('[data-ocea-cta-was]'), ctaPrice = root.querySelector('[data-ocea-cta-price]');
      var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-ocea-gift]'));
      var savePrefix = root.dataset.savePrefix || 'SALE — SAVE';
      function selected() { return inputs.filter(function (i) { return i.checked; })[0] || inputs[0]; }
      function detail(i) { return { variantId: i.value, tier: parseInt(i.dataset.tier, 10), bottles: parseInt(i.dataset.bottles, 10), total: i.dataset.total, was: i.dataset.was, save: i.dataset.save, title: i.dataset.title }; }
      function paint() {
        var cur = selected(); var d = detail(cur); var tier = d.tier;
        inputs.forEach(function (i) { i.closest('[data-ocea-tier]').classList.toggle('is-selected', i === cur); });
        if (price) price.textContent = d.total;
        if (save) save.textContent = savePrefix + ' ' + d.save;
        if (ctaWas) ctaWas.textContent = d.was;
        if (ctaPrice) ctaPrice.textContent = d.total;
        gifts.forEach(function (g) { g.classList.toggle('is-locked', tier < parseInt(g.dataset.unlock, 10)); });
        if (window.Ocea) window.Ocea.setPlan(d);
      }
      inputs.forEach(function (i) { i.addEventListener('change', paint); });
      paint();
      document.addEventListener('ocea:select-plan', function (e) { var t = e.detail && e.detail.tier; var i = inputs.filter(function (x) { return parseInt(x.dataset.tier, 10) === t; })[0]; if (i && !i.disabled) { i.checked = true; paint(); } });
    }

    /* --- сразу чекаут: cart permalink --- */
    function initDirectCheckout(form) {
      if (form.hasAttribute('data-no-product')) { form.addEventListener('submit', function (e) { e.preventDefault(); }); return; }
      form.addEventListener('submit', function (e) {
        var sel = form.querySelector('input[name="id"]:checked');
        if (!sel || !/^\d+$/.test(sel.value)) return;
        e.preventDefault();
        var btn = form.querySelector('[name="add"]'); if (btn) btn.setAttribute('aria-busy', 'true');
        if (window.Ocea) window.Ocea.checkout(sel.value);
        else window.location.assign('/cart/' + sel.value + ':1');
      });
    }

    /* --- дата доставки: cut-off + N рабочих дней → "Tue, Sep 23" --- */
    function initArrival(root) {
      var el = root.querySelector('[data-ocea-arrival]'); if (!el) return;
      var days = parseInt(root.dataset.arrivalDays, 10) || 4; var cutoff = parseInt(root.dataset.cutoffHour, 10) || 14;
      var d = new Date(); if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
      var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      try { el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
      catch (e) { el.textContent = 'in 2-4 working days'; }
    }

    /* --- галерея: 10 кадров, окно из 5 превью едет за активным (кадр 7 → окно 3–7), стрелки и свайп по кругу,
           растворение 0.12 с, по активному превью ничего не происходит --- */
    function initGallery(root) {
      var g = root.querySelector('[data-ocea-gallery]'); if (!g) return;
      var img = g.querySelector('[data-ocea-hero-img]'); var fade = g.querySelector('[data-ocea-hero-fade]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-ocea-thumb]'));
      if (!img || !thumbs.length) return;
      var n = thumbs.length, WIN = 5, current = 0, busy = null;
      function windowStart(k) { return Math.max(0, Math.min(n - WIN, k - (WIN - 1))); }
      function paintThumbs(k) {
        var st = windowStart(k);
        thumbs.forEach(function (t, i) {
          t.hidden = i < st || i >= st + WIN;
          t.setAttribute('aria-current', i === k ? 'true' : 'false');
        });
      }
      function show(k) {
        k = (k + n) % n; if (k === current) return;
        current = k; paintThumbs(k);
        var src = thumbs[k].dataset.full;
        if (REDUCED.matches || !fade) { img.src = src; return; }
        if (busy) clearTimeout(busy);
        fade.classList.remove('is-in');
        fade.onload = function () {
          fade.onload = null;
          void fade.offsetWidth; fade.classList.add('is-in');
          busy = setTimeout(function () { img.src = src; img.onload = function () { img.onload = null; fade.classList.remove('is-in'); }; busy = null; }, 130);
        };
        fade.src = src;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { if (k !== current) show(k); }); });
      var prev = g.querySelector('[data-ocea-prev]'), next = g.querySelector('[data-ocea-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var hero = img.parentNode, x0 = null, y0 = null;
      hero.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; x0 = e.clientX; y0 = e.clientY; });
      hero.addEventListener('pointerup', function (e) {
        if (x0 === null) return; var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        show(dx < 0 ? current + 1 : current - 1);
      });
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
      });
      /* кадры грузим заранее, когда галерея на экране — переходы без пустого кадра */
      if (window.Ocea && window.Ocea.onEnter) window.Ocea.onEnter(g, function () { thumbs.forEach(function (t) { var i = new Image(); i.src = t.dataset.full; }); }, 0.01);
      paintThumbs(0);
    }

    /* --- REVIEWS: страницы по три, стрелки и свайп по кругу --- */
    function initReviews(root) {
      var w = root.querySelector('[data-ocea-reviews]'); if (!w) return;
      var grid = w.querySelector('[data-ocea-reviews-grid]');
      var cards = Array.prototype.slice.call(w.querySelectorAll('[data-page]'));
      var pages = cards.reduce(function (m, c) { return Math.max(m, parseInt(c.dataset.page, 10) + 1); }, 1);
      if (pages < 2) return;
      var page = 0;
      function go(p) {
        p = (p + pages) % pages; if (p === page) return;
        var apply = function () { page = p; cards.forEach(function (c) { c.hidden = parseInt(c.dataset.page, 10) !== page; }); };
        if (REDUCED.matches) { apply(); return; }
        grid.classList.add('is-switching');
        setTimeout(function () { apply(); grid.classList.remove('is-switching'); }, 150);
      }
      var prev = w.querySelector('[data-ocea-reviews-prev]'), next = w.querySelector('[data-ocea-reviews-next]');
      if (prev) prev.addEventListener('click', function () { go(page - 1); });
      if (next) next.addEventListener('click', function () { go(page + 1); });
      var x0 = null, y0 = null;
      grid.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; });
      grid.addEventListener('pointerup', function (e) {
        if (x0 === null) return; var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        go(dx < 0 ? page + 1 : page - 1);
      });
    }

    /* --- аккордеон: высота анимируется через grid-template-rows, закрытие ждёт transitionend --- */
    function initAccordion(root) {
      var wrap = root.querySelector('[data-ocea-accordion]'); if (!wrap) return;
      Array.prototype.slice.call(wrap.querySelectorAll('details')).forEach(function (d) {
        var body = d.querySelector('.ocea-offer__acc-body'); var head = d.querySelector('summary');
        head.addEventListener('click', function (e) {
          e.preventDefault();
          if (d.open && !d.classList.contains('is-closing')) {
            if (REDUCED.matches) { d.open = false; return; }
            d.classList.add('is-closing');
            var done = function () { d.open = false; d.classList.remove('is-closing'); body.removeEventListener('transitionend', done); };
            body.addEventListener('transitionend', done); setTimeout(done, 340);
          } else { d.classList.remove('is-closing'); d.open = true; }
        });
      });
    }

    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var form = root.querySelector('[data-ocea-offer-form]');
      if (form) { initPlans(root, form); initDirectCheckout(form); }
      initArrival(root); initGallery(root); initReviews(root); initAccordion(root);
    }
    document.querySelectorAll('.ocea-offer').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-offer'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      if (!root.querySelector('.ocea-reviews__item.is-extra')) root.classList.add('has-no-extra');
      var more = root.querySelector('[data-ocea-reviews-more]');
      if (more) more.addEventListener('click', function () { root.classList.add('is-expanded'); });
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ocea-vote]'); if (!b) return;
        var wrap = b.parentNode; wrap.querySelectorAll('[data-ocea-vote]').forEach(function (x) { x.classList.toggle('is-active', x === b && !x.classList.contains('is-active')); });
      });
    }
    document.querySelectorAll('.ocea-reviews').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-reviews'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Лента: перетаскивание мышью на десктопе поверх нативного скролла + колесо мыши */
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var lane = root.querySelector('[data-ocea-lane]'); if (!lane) return;
      if (window.Ocea) Ocea.eagerNear(lane);
      var down = false, x0 = 0, s0 = 0, moved = false;
      lane.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = lane.scrollLeft; lane.classList.add('is-dragging'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 3) moved = true; lane.scrollLeft = s0 - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; lane.classList.remove('is-dragging'); });
      lane.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

      /* Колесо мыши (правки 28.09, п. 6): вертикальное колесо над лентой листает её по карточке (снап x mandatory — шаг = карточка + зазор),
         пока лента не упрётся в край, — тогда событие уходит странице, читатель не застревает. Тачпад шлёт много мелких дельт:
         копим до 40 px и не листаем дальше, пока идёт перелистывание (иначе инерция пролетает пол-ленты). Горизонтальные жесты и зум — нативно */
      var acc = 0, lock = 0;
      function pitch() { var k = lane.children; return k.length > 1 ? k[1].offsetLeft - k[0].offsetLeft : lane.clientWidth; }
      lane.addEventListener('wheel', function (e) {
        if (e.ctrlKey || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
        var max = lane.scrollWidth - lane.clientWidth; if (max <= 1) return;
        var d = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? lane.clientWidth : 1);
        if ((d < 0 && lane.scrollLeft <= 1) || (d > 0 && lane.scrollLeft >= max - 1)) { acc = 0; return; }
        e.preventDefault();
        var now = Date.now(); if (now < lock) return;
        acc += d; if (Math.abs(acc) < 40) return;
        var reduced = window.Ocea && Ocea.reduced && Ocea.reduced.matches;
        lane.scrollBy({ left: (acc > 0 ? 1 : -1) * pitch(), behavior: reduced ? 'auto' : 'smooth' });
        acc = 0; lock = now + 320;
      }, { passive: false });
    }
    document.querySelectorAll('.ocea-social').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-social'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Шкала по прототипу: Step 0 → 1: пауза 0.6s, шаг 0.6s; N → Np: 0.05s + 0.55s; Np → N+1: 0.35s + 0.6s (ease-out).
       Запуск — по каждой фазе отдельно (правки 28.09, п. 4): фаза раскрывается, когда её шапка поднялась выше нижней четверти экрана.
       Если в кадр вошло сразу несколько (высокий экран, быстрый скролл) — идут по очереди в том же ритме, анимация не убегает от читателя.
       prefers-reduced-motion — сразу финальное состояние без пульса. */
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    function targets(rail, phases) {
      var railTop = rail.getBoundingClientRect().top;
      return phases.map(function (p, i) {
        if (i === phases.length - 1) return rail.getBoundingClientRect().height;
        var m = p.querySelector('[data-ocea-marker]').getBoundingClientRect();
        return m.top + m.height / 2 - railTop;
      });
    }
    function run(rail) {
      var bar = rail.querySelector('[data-ocea-progress]');
      var phases = Array.prototype.slice.call(rail.querySelectorAll('[data-ocea-phase]'));
      if (!bar || !phases.length) return;
      var step = -1;
      var place = function () { if (step >= 0) bar.style.height = targets(rail, phases)[step] + 'px'; };
      window.addEventListener('resize', place);           /* высоты фаз меняются с шириной — линия всегда на центре пина */
      if (REDUCED.matches || !('IntersectionObserver' in window)) { step = phases.length - 1; phases.forEach(function (p) { p.classList.add('is-on', 'is-pulsed'); }); place(); return; }
      var due = -1, shown = -1, busy = false;
      function advance() {
        if (busy || shown >= due) return;
        busy = true;
        var k = shown + 1;
        setTimeout(function () {
          step = k; shown = k; place(); phases[k].classList.add('is-on');                                  /* шаг 0.6s (CSS) */
          setTimeout(function () { phases[k].classList.add('is-pulsed'); }, 650);                           /* N → Np: 0.05 + 0.55 */
          setTimeout(function () { busy = false; advance(); }, 650 + 550);
        }, k === 0 ? 600 : 350);                                                                             /* 0 → 1: 0.6; Np → N+1: 0.35 */
      }
      var heads = phases.map(function (p) { return p.querySelector('.ocea-timeline__head') || p; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          due = Math.max(due, heads.indexOf(en.target));
        });
        advance();
      }, { rootMargin: '0px 0px -25% 0px', threshold: 0 });
      heads.forEach(function (h) { io.observe(h); });
    }
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var rail = root.querySelector('[data-ocea-timeline]'); if (!rail) return;
      run(rail);
    }
    document.querySelectorAll('.ocea-timeline').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-timeline'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocea-what-changes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* 1920/1280 — статичный список (весь текст виден), 768/402 — аккордеон: одна строка открыта, «+» → «−», 0.3s ease-out */
    var MQ = window.matchMedia('(max-width: 1023px)');
    function init(root) {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ocea-what-row]'));
      function sync() {
        rows.forEach(function (r) {
          var btn = r.querySelector('[data-ocea-what-toggle]');
          if (MQ.matches) { btn.setAttribute('aria-expanded', r.classList.contains('is-open') ? 'true' : 'false'); btn.removeAttribute('tabindex'); btn.removeAttribute('aria-disabled'); }
          else { btn.removeAttribute('aria-expanded'); btn.setAttribute('tabindex', '-1'); btn.setAttribute('aria-disabled', 'true'); }
        });
      }
      rows.forEach(function (row) {
        row.querySelector('[data-ocea-what-toggle]').addEventListener('click', function () {
          if (!MQ.matches) return;
          var open = !row.classList.contains('is-open');
          rows.forEach(function (r) { r.classList.toggle('is-open', r === row && open); });
          sync();
        });
      });
      if (MQ.addEventListener) MQ.addEventListener('change', sync); else if (MQ.addListener) MQ.addListener(sync);
      sync();
    }
    document.querySelectorAll('.ocea-what').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ocea-what'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();
})();
